import { Button } from "components/DesignSystem/Button/Button";
import Input from "components/DesignSystem/Input/Input";
import { ClosedEye } from "components/icons/ClosedEye";
import { CrossedEye } from "components/icons/CrossedEye";
import { useState } from "react";

type SensitiveDataPasswordFieldProps = {
  label: string;
  name: string;
  value: string;
  placeholder?: string;
  required?: boolean;
};

export const SensitiveDataPasswordField = ({
  label,
  name,
  value,
  placeholder,
  required,
}: SensitiveDataPasswordFieldProps) => {
  const [isRevealed, setIsRevealed] = useState(false);

  const hasValue = Boolean(value);
  const isVisible = isRevealed && hasValue;

  const handleToggleVisibility = () => {
    setIsRevealed((current) => !current);
  };

  return (
    <Input
      withForm
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      type={isVisible ? "text" : "password"}
      rightComponent={
        <Button
          type="button"
          size="xxsmall"
          customType="ghost_icon"
          onClick={handleToggleVisibility}
          disabled={!hasValue}
          title={isVisible ? "Hide password" : "Show password"}
        >
          <span className="t-flex t-text-text-30">
            {isVisible ? <CrossedEye /> : <ClosedEye />}
          </span>
        </Button>
      }
    />
  );
};
